import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { MediaService } from '../media.service';
import { ModelService } from '../../product/model.service';
import { MediaGridItem } from '../media-grid/media-grid.component';

@Component({
  selector: 'app-images-page',
  templateUrl: './images-page.component.html',
  styleUrls: ['./images-page.component.css']
})
export class ImagesPageComponent implements OnInit, OnDestroy {
  private mediaService = inject(MediaService);
  private modelService = inject(ModelService);
  private destroy$ = new Subject<void>();

  items: MediaGridItem[] = [];
  loading = true;
  private modelNames = new Map<string, string>();

  ngOnInit(): void {
    this.loadImages();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadImages(): void {
    this.loading = true;
    this.mediaService.getLatestImages(24).pipe(takeUntil(this.destroy$)).subscribe({
      next: (images) => {
        this.items = images.map(img => ({
          type: 'image' as const,
          data: img,
          modelName: ''
        }));
        this.loading = false;
        this.resolveModelNames(images.map(i => i.userId));
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  private resolveModelNames(userIds: string[]): void {
    const unique = [...new Set(userIds)];
    unique.forEach(uid => {
      if (this.modelNames.has(uid)) return;
      this.modelService.getModelById(uid).pipe(takeUntil(this.destroy$)).subscribe({
        next: (model) => {
          this.modelNames.set(uid, model.name);
          this.items = this.items.map(item =>
            item.data.userId === uid ? { ...item, modelName: model.name } : item
          );
        },
        error: () => {
          this.modelNames.set(uid, 'Unknown');
        }
      });
    });
  }
}
